import { Button } from "@fluentui/react-components";
import { PersonSquareCheckmark24Regular } from "@fluentui/react-icons";
import { Flex, StyledTooltip } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import { EmployeeRowItem, IEmployeeView } from "library/types";
import { useCallback, useState } from "react";
import { EligibilityFormDialog } from "./EligibilityFormDialog/EligibilityFormDialog";
import { useRoleType } from "hooks/useRoleType";
import { useParams } from "react-router-dom";

type Props = {
  employeeData: EmployeeRowItem;
  dependentData?: IEmployeeView;
  disabled?: boolean;
};

export function EmployeeEligibility({
  employeeData,
  dependentData,
  disabled = false,
}: Props) {
  const { palette } = useAppTheme();
  const params = useParams();
  const packageId = params.packageId;
  const isReadOnlyUser = useRoleType()?.hasHrReadOnly;
  const disabledAction = !!employeeData.disabled || isReadOnlyUser || disabled;

  const [addEligibilityOpen, setAddEligibilityOpen] = useState(false);

  const handleDialogStateChange = useCallback(() => {
    setAddEligibilityOpen((prev) => !prev);
  }, []);

  return (
    <>
      <Flex width={"100%"} justify="center">
        <StyledTooltip
          relationship="label"
          content={{
            children: "Manage Package Eligibility",
          }}
        >
          <Button
            icon={
              <PersonSquareCheckmark24Regular
                style={{
                  ...(disabledAction ? {} : { color: palette.purpleDark }),

                  transform: "scale(1.1)",
                }}
              />
            }
            disabled={disabledAction}
            appearance="transparent"
            size="small"
            onClick={() => {
              setAddEligibilityOpen(true);
            }}
          />
        </StyledTooltip>
      </Flex>
      {addEligibilityOpen && (
        <EligibilityFormDialog
          benefitPackageTag={packageId ? Number(packageId) : undefined}
          packageUser={
            dependentData
              ? {
                  ...dependentData,
                  dateOfEmployment: employeeData?.dateOfEmployment,
                }
              : employeeData
          }
          employeeEnrollmentTag={employeeData?.employeeEnrollmentTag}
          open={addEligibilityOpen}
          setOpen={handleDialogStateChange}
        />
      )}
    </>
  );
}
